import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import ReactMarkdown from 'react-markdown';
import { useProvider } from '../../context/MenuProvider';
import Swal from 'sweetalert2';

const InstalarIos = ({ isMobile, isOnSafari }) => {
  return (
    <>
      {isMobile && (
        <div>
          <h3>Instalar no iPhone / iPad</h3>
          <ol>
            {!isOnSafari && (<li>Abra este site no Safari</li>)}
            <li>Toque em Compartilhar</li>
            <li>Toque em “Adicionar à Tela de Início”</li>
            <li>Confirme em Adicionar</li>
          </ol>
        </div>
      )}

      {!isMobile && (
        <div>
          <h3>Instalar no Mac</h3>
          <ol>
            {!isOnSafari && (<li>Abra este site no Safari</li>)}
            <li>Clique em Arquivo → Adicionar à Tela de Início</li>
            <li>Confirme em Adicionar</li>
          </ol>
        </div>
      )}
    </>
  );
};

const InstalarApp = ({ open }) => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(false);
  const [isiOS, setIsiOS] = useState(false);
  const [isOnSafari, setIsOnSafari] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isiOSInstalado, setIsiOSInstalado] = useState(false);
  const [instalarNoIos, setInstalarNoIos] = useState(false);
  const {
    site
  } = useProvider();

  useEffect(() => {
    // Detectar iOS e Safari
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isSafari = userAgent.includes('safari') && !userAgent.includes('chrome');
    const isAppleDevice = /iphone|ipad|ipod/.test(userAgent);
    const isDeviceMobile = /mobile|android|iphone|ipad|ipod/.test(userAgent);
    
    if (isSafari && isAppleDevice) {
      const iosInstalado = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
      setIsiOS(true);
      setIsiOSInstalado(iosInstalado);
    }else {
      setIsiOS(isAppleDevice);
    }
    setIsMobile(isDeviceMobile);
    setIsOnSafari(isSafari);

    // Ouvindo o evento 'beforeinstallprompt' (somente Android)
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      if (isiOS){
        setInstalarNoIos(true);
        return;
      }
      if (isMobile && site?.pacote_android){
        Swal.fire({
          title: "Instalar pela Play Store",
          text: "Este Aplicativo tem a versão universal e a nativa para Android na Play Store",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#3085d6",
          cancelButtonText: "Continuar",
          confirmButtonText: "Play Store"
        }).then(async(result) => {
          if (result.isConfirmed) {
            window.location.href = `https://play.google.com/store/apps/details?id=${site?.pacote_android}`;
          }
          else{
            installPwa();
          }
        });
      }
      else{
        installPwa();
      }
    }
  };
  const installPwa = ()=>{
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('Usuário aceitou instalar o PWA');
        } else {
          console.log('Usuário recusou instalar o PWA');
        }
        setDeferredPrompt(null);
        setShowInstallButton(false);
      });
  }
  

  return (<>
    <div className="text-center py-2">
      {(open || showInstallButton) && (
        <div id="install-button">
          <div className="text-center text-muted small">Instale o App</div>
          <Button
            onClick={() => (showInstallButton ? handleInstallClick() : open && window.open(window.location.origin))}
            className="download-btn"
            variant="primary"
            size="lg"
          >
            <i className="bx bxl-android"></i> Android
          </Button>
          <Button
            onClick={() => (showInstallButton ? handleInstallClick() : open && window.open(window.location.origin))}
            className="download-btn"
            variant="secondary"
            size="lg"
          >
            <i className="bx bxl-apple"></i> IOS
          </Button>
          <Button
            onClick={() => (showInstallButton ? handleInstallClick() : open && window.open(window.location.origin))}
            className="download-btn"
            variant="success"
            size="lg"
          >
            <i className="bx bx-desktop"></i> PC
          </Button>
        </div>
      )}
    </div>
    {instalarNoIos && (<InstalarIos isMobile={isMobile} isOnSafari={isOnSafari}/>)}
  </>
  );
};

export default InstalarApp;